import { InputField } from "@risalabs_frontend_org/oasis-ui-kit";
import EditPencilIcon from "../../../../svg/editPencil";

interface PasswordFieldProps {
  error: string | undefined;
  isEditMode: boolean;
  isEditing: boolean;
  onEditClick: () => void;
  onChange: (value: string) => void;
  onBlur: () => void;
}

/**
 * Password input with the optional edit-pencil icon used in edit mode.
 *
 * In edit mode the field starts read-only with a masked placeholder so
 * the stored value is never echoed back; clicking the pencil flips the
 * field into edit mode (callers wire `onEditClick` to also mark the
 * field touched so its "required" error surfaces if left blank).
 *
 * Always uses `defaultValue=""` (uncontrolled) so React doesn't try to
 * sync the plaintext password back into form state on every keystroke
 * via a controlled value.
 */
export const PasswordField = ({
  error,
  isEditMode,
  isEditing,
  onEditClick,
  onChange,
  onBlur,
}: PasswordFieldProps) => (
  <div className="flex w-full flex-row items-center gap-3">
    <div className="w-full">
      <InputField
        label="Password"
        size="md"
        fullWidth
        type="password"
        required={!isEditMode || isEditing}
        hint={
          isEditMode
            ? "Click the pencil icon to overwrite the stored password."
            : "Will be encrypted before storage."
        }
        error={error}
        defaultValue=""
        id="password"
        readOnly={isEditMode && !isEditing}
        placeholder={
          isEditMode && !isEditing ? "••••••••••••••••" : "Enter password"
        }
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
      />
    </div>
    {isEditMode && (
      <div className="mt-5 cursor-pointer" onClick={onEditClick}>
        <EditPencilIcon height={20} width={20} />
      </div>
    )}
  </div>
);
